import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { thisBaseURL } from "../../utils/helper.js";
require("highcharts/modules/accessibility")(Highcharts);

Highcharts.setOptions({
    credits: { enabled: false },
    lang: {
      thousandsSep: ','
    }
  });
  
function ImportExportValue({foodAnswers}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let importValue = foodAnswers.answerKeyValues['u_s_imports_value'];
	let importValueYear = foodAnswers.answerKeyValues['u_s_imports_value_year'];
	let importValueSourceRef = foodAnswers.answerKeyValues['u_s_imports_value_sources'];
	let importValueNotes = foodAnswers.answerKeyValues['u_s_imports_value_notes'];
	
	let exportValue = foodAnswers.answerKeyValues['u_s_exports_value'];
	//let exportValueYear = foodAnswers.answerKeyValues['u_s_exports_value_year'];
	//let exportValueSourceRef = foodAnswers.answerKeyValues['u_s_exports_value_sources'];
	let exportValueNotes = foodAnswers.answerKeyValues['u_s_exports_value_notes'];
	
	let array = [];
	let importDataSeries = [];
	let xCategories = [];
	if (importValue) {
		try {
			array = JSON.parse(importValue);
		} catch (err) {
			console.log("ImportExportValue :importValue: " + err);
		}
		importDataSeries = array.map(function(obj) {
			if (obj && obj["usd"]) {
				return [parseFloat(obj["usd"].replace(/,/g, ''))];
			}
		});
		xCategories = array.map(function(obj) {
			if (obj && obj["year"]) {
				return [parseInt(obj["year"])];
			}
		});
	}

	let exportDataSeries = [];
	if (exportValue) {
		try {
			array = JSON.parse(exportValue);
		} catch (err) {
			console.log("ImportExportValue :exportValue: " + err);
		}
		exportDataSeries = array.map(function(obj) {
			if (obj && obj["usd"]) {
				return [parseFloat(obj["usd"].replace(/,/g, ''))];
			}
		});
	}
	
	return(
			<div>
				<h2 style={{textAlign: "center"}}>
					US Imports and Exports by Value&nbsp;
					{importValueYear ? 
					<small>&nbsp;({importValueYear})</small>
					: ""}
					{ importValueSourceRef && importValueSourceRef > 0 ?
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+importValueSourceRef}>{importValueSourceRef}</a></small>:
					""	
					}
				</h2>
				<HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: "60vw" } }}
				options={{
					chart: {
						type: 'column'
					},
					credits: {
						enabled: false
					},
					lang: {
						thousandsSep: ','
					},
					title: {
						text: ''
					},
					yAxis: {
						labels: {
							formatter: function() {
								let imports_len = (Math.max(...importDataSeries) + "").length || 0;
								let exports_len = (Math.max(...exportDataSeries) + "").length || 0;
								let len = Math.max(imports_len, exports_len);
								if (len >= 7 && len < 10) {
									return '$' +this.value / 1000000 + 'm';
								}
								if (len >= 10) {
									return '$' +this.value / 1000000000 + 'bn';
								}
								if (len < 7) {
									return '$' +this.value;
								}
							}
						},
						title: {
							text: "USD"
						}
					},
					xAxis: {
						title: {
							text: ''
						},
						categories: xCategories
					},
					series: [
						{
							name: "US Imports(USD)",
							data: importDataSeries
						},
						{
							name: "US Exports(USD)",
							data: exportDataSeries
						}
					]
				}}
				/>
				<p className="notes-info" style={{marginTop: "auto"}}>
				{(importValueNotes) || (exportValueNotes) ? 
				<em>
				{(importValueNotes ) ? 
					importValueNotes
					: ""}
				{(importValueNotes)  ? <br /> :""}
				{(exportValueNotes ) ? 
					exportValueNotes
				: ""}
				</em>
				:""}
				</p>
			</div>
		)
}
export default ImportExportValue;